import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const MAPLOCATIONBLOCK_LEGACY_FIELD_ORDER = [
  "address",
  "name"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  mapLocationBlockDescriptor: _generatedMapLocationBlockDescriptor,
  mapLocationBlockBlocDefinition,
  mapLocationBlockDashboardLayout,
  mapLocationBlockConfig,
  mapLocationBlockResolveConfig,
  mapLocationBlockProperties,
} = doodBlockConfig(
  {
    name: "Map - Location",
    componentType: 'MapLocationBlockComponent',
    category: 'content',
    description: "Map - Location.",
    keywords: [],
    hideFromPicker: true,
    sharedFields: {}
  },

  () => ({
    address: propertyValue({
      type: 'location',
      value: '',
      options: {
        label: "pages.blocks.map-location.address.label",
      }
    }),
    name: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.map-location.name.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.map-location.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.map-location.fieldset.location.label",
            fields: ["address", "name"],
          },
        ],
      },
    ],
  })
);

export function mapLocationBlockDescriptor(): IBlockDescriptor;
export function mapLocationBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function mapLocationBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedMapLocationBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedMapLocationBlockDescriptor, mapLocationBlockProperties, fieldOrder);
}

export {
  mapLocationBlockBlocDefinition,
  mapLocationBlockDashboardLayout,
  mapLocationBlockProperties,
  mapLocationBlockConfig,
  mapLocationBlockResolveConfig,
};

export type MapLocationBlockConfig = typeof mapLocationBlockConfig;
